import resolveFacilityPlacement from '@UI/Pages/Beneficiaries/BeneficiaryList/Helpers/resolveFacilityPlacement';
import useCurrentFacility from '@UI/Providers/CurrentFacilityProvider/useCurrentFacility';
import useCurrentOrganization from '@UI/Providers/CurrentOrganizationProvider/useCurrentOrganization';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Opens a dossier at `destination`, switching to its facility first when it belongs to another one:
 * the organization is selected before the facility, then the facility switch navigates to the destination.
 */
const useSubjectOpener = (): ((destination: string, facilityId: number) => void) => {
	const navigate = useNavigate();
	const { organizations, selectOrganization } = useCurrentOrganization();
	const { currentFacility, selectFacility } = useCurrentFacility();
	const currentFacilityId = currentFacility?.id ?? null;

	return React.useCallback(
		(destination: string, facilityId: number) => {
			if (facilityId === currentFacilityId) {
				navigate(destination);
				return;
			}

			const placement = resolveFacilityPlacement(facilityId, organizations);

			if (placement === null) {
				navigate(destination);
				return;
			}

			selectOrganization(placement.organizationId);
			selectFacility(facilityId, { redirectTo: destination });
		},
		[currentFacilityId, navigate, organizations, selectOrganization, selectFacility],
	);
};

export default useSubjectOpener;
